import React from "react";
import { default as CostBoxSettlement } from "../Settlement/CostBox";
import DivorcePlannerBox from "../Divorce/DivorcePlannerBox";
import DivorceCostBox from "../Divorce/CostBox/DivorceCostBox";
import { AbstractCase } from "../../../types/Entities/AbstractCase";

type ServiceWorldCaseProductBoxesProps = {
  product: AbstractCase;
};

const ServiceWorldCaseProductBoxes = ({ product }: ServiceWorldCaseProductBoxesProps) => {
  switch (product.name) {
    case "alimony":
      return null;
    case "divorce":
      return (
        <>
          <DivorcePlannerBox product={product} />
          {product.paymentType !== "insurance" && <DivorceCostBox divorce={product} />}
        </>
      );
    case "death":
      return null;
    case "familyLawCase":
      return null;
    case "settlement":
      return (
        <>
          <CostBoxSettlement settlement={product} />
        </>
      );
    case "traffic":
      return null;
    case "eventContract":
    case "membershipContract":
    case "otherContract":
    case "providerContract":
    case "purchaseContract":
    case "serviceContract":
    case "subscriptionContract":
    case "travelContract":
    case "vehicleContract":
    case "dataLeakContract":
      return null;
    default:
      return null;
  }
};

export default ServiceWorldCaseProductBoxes;
